import { useState, useEffect, React } from "react"
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../config/msalConfig';
import '../Styles/Categoria.css';
import '../Styles/Obituario.css';
import { api } from '../api.js';
import MicrosoftLogo from '../Components/MicrosoftLogo';
import { renderCategoryDisplay } from '../utils/categoryUtils';

function Categoria() {
  const [user, setUser] = useState(null);
  const [search, setSearch] = useState('');
  const [contrato, setContrato] = useState([]);

  const { instance, accounts } = useMsal();
  const isAuthenticated = accounts.length > 0;

  useEffect(() => {
    if (isAuthenticated) {
      // User is authenticated with MSAL, set user data
      const account = accounts[0];
      setUser({
        name: account.name,
        email: account.username,
        provider: 'microsoft',
      });
    }
  }, [isAuthenticated, accounts]);

  function getCategory() {
    if (!search || search.trim() === '') {
      alert('Por favor, digite o número do contrato');
      return;
    }
    
    switchLoader(1);
    api
      .get('/pegasus/category', { params: { contrato: search } })
      .then((res) => {
        console.log('Resposta da API:', res.data);
        const cto = res.data.cto;
        if (cto !== null) {
          setContrato([
            {
              categoria: cto.categoria,
              numero: cto.numero,
              data: typeof cto.data === 'string' ? cto.data.replace('.', '') : cto.data,
            },
          ]);
        } else {
          setContrato([null]);
        }

        switchLoader(0);
      })
      .catch((error) => {
        console.error('Erro ao buscar categoria:', error);
        alert('Erro ao buscar contrato. Verifique o console para mais detalhes.');
        switchLoader(0);
      });
  }

  const handleLogin = async () => {
    try {
      await instance.loginPopup(loginRequest);
    } catch (error) {
      console.error('Login failed:', error);
    }
  };

  const handleLogout = async () => {
    try {
      await instance.logoutPopup();
      setUser(null);
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };

  function switchLoader(n) {
    let loader = document.getElementById('wrapper');
    n === 0 ? (loader.style.display = 'none') : (loader.style.display = 'flex');
  }

  if (!user) {
    return (
      <div className="profile-page">
        <div className="profile-content">
          <div className="profile-login-card">
            <div className="luto-icon" style={{ textAlign: 'center' }}>
              <img
                alt="icon luto"
                src="icon-luto.png"
                width="200px"
                height="auto"
              ></img>
            </div>
            <div
              className="profile-login-card-top"
              style={{ marginTop: '20px' }}
            >
              <h1>Página de Fidelidade</h1>
            </div>
            <div className="profile-login-card-buttons">
              <div
                className="profile-login-buttons"
                style={{ width: '400px' }}
                onClick={handleLogin}
              >
                <MicrosoftLogo width="45px" height="45px" />
                <p style={{ textAlign: 'center', marginLeft: '5px' }}>
                  Entrar com Microsoft
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="page">
      <div id="wrapper" style={{ display: 'none' }}>
        <div id="loader"></div>
      </div>

      <div className="page-content">
        <div className="sv-title-div">
          <div style={{ width: '33%', textAlign: 'left' }}>
            <img
              alt="icon luto"
              src="icon-luto.png"
              width="40px"
              height="40px"
              style={{ marginLeft: '1vw' }}
            ></img>
          </div>
          <h1 style={{ width: '34%' }}>Categoria do contrato</h1>
          <div
            style={{
              width: '33%',
              height: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'right',
            }}
          >
            <div onClick={handleLogout} className="logout-bnt">
              Sair
            </div>
          </div>
        </div>

        <div className="search-contract-div">
          <div className="form">
            <p style={{ fontSize: '26px' }}>Número do contrato</p>
            <input
              type="text"
              placeholder="0"
              className="search-input"
              style={{
                border: '1px solid black',
                width: '220px',
                marginTop: '10px',
              }}
              onChange={(e) => setSearch(e.target.value)}
            ></input>
            <button
              type="submit"
              className="search-button"
              style={{ width: '250px', marginTop: '10px' }}
              onClick={() => getCategory()}
            >
              Buscar
            </button>
          </div>

          {contrato[0] !== null ? (
            contrato.map((cto, i) => {
              const categoryDisplay = renderCategoryDisplay(cto.categoria);
              return (
                <div
                  className="form"
                  style={{
                    marginTop: '50px',
                    border: '1px solid black',
                    borderRadius: '5px',
                    width: 'auto',
                    padding: '20px 10px',
                    fontSize: '20px',
                    textAlign: 'center',
                    whiteSpace: 'nowrap',
                    boxSizing: 'content-box',
                  }}
                  key={i}
                >
                  <p>Número do Contrato: {cto.numero}</p>
                  <p>Ano do contrato: {cto.data}</p>
                  <div
                    style={{
                      width: '250px',
                      height: '40px',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      marginTop: '5px',
                      ...categoryDisplay.style,
                    }}
                  >
                    <p
                      style={{
                        fontFamily: 'Roboto Medium',
                        fontSize: '22px',
                        color: categoryDisplay.style.color,
                      }}
                      className="sv-info"
                    >
                      {categoryDisplay.name}
                    </p>
                  </div>
                  <br />
                  {categoryDisplay.image && (
                    <img src={categoryDisplay.image} alt="beneficios" />
                  )}
                </div>
              );
            })
          ) : (
            <div className="form" style={{ marginTop: '50px' }}>
              <p style={{ fontSize: '24px' }}>Contrato não encontrado</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Categoria